export default __webpack_public_path__ + "static/media/node.502737ea.svg";